export const animationTypes = {

    NONE: 'NONE',
    SCROLL_BUBBLES: 'SCROLL_BUBBLES'

}